<template>
    <a :href="href" target="_blank" class="d-flex">

            <img :src="src" :height="height" :width="width" />
    </a>
</template>

<script>
    const logo = require("@/assets/logo2.svg")
    import widgetMixin from '../mixins/widgetMixin'
    export default {
        mixins: [widgetMixin],
        props: {
            height: {
                type: [String, Number],
                require: false,
                default: "36"
            },
            width: {
                type: [String, Number],
                require: false,
                default: "36"
            }
        },
        computed: {
            src() {
                return this.iconUrl ? this.iconUrl : logo
            },
            href() {
                return this.mainSite ? this.mainSite : 'http://www.sistemagorod.ru'
            }
        }
    }
</script>

<style>

</style>